import React, { PropTypes } from 'react'
import moment from 'moment-timezone'

import { formatDate, pluralizedWeekday } from 'utils/dates'
import { serviceTypes, TIMEZONE } from '@src/globals'

const ChangeSummary = ({ replacedAliada, replacementAliada, booking, bookingTypeId }) => {
  let formattedChange
  let formattedBookingDate
  let format

  const recurrenceMoment = 'weekday' in booking ? moment.tz(Date.now(0), TIMEZONE).day(booking.weekday).hour(booking.hour).minute(0) : null

  switch (bookingTypeId) {
    case serviceTypes.WEEKLY.id:
    case serviceTypes.MULTIPLE.id:
    case serviceTypes.BIWEEKLY.id:
      const weekday = pluralizedWeekday(recurrenceMoment)
      format = 'h:mm A'
      formattedBookingDate = formatDate(format, recurrenceMoment)
      formattedChange = `de la recurrencia de los ${weekday} a las ${formattedBookingDate}`
      break
    case serviceTypes.ONE_TIME.id:
      format = 'dddd D [de] MMMM [a las] H:mm A'
      formattedBookingDate = formatDate(format, booking.datetime)
      formattedChange = `del servicio del ${formattedBookingDate}`
      break
  }

  return (
    <p>
      {`${replacementAliada.firstName} se hará cargo ${formattedChange} en lugar de ${replacedAliada.firstName}.`}
    </p>
  )
}

ChangeSummary.displayName = 'ChangeSummary'
ChangeSummary.propTypes = {
  replacedAliada: PropTypes.object.isRequired,
  replacementAliada: PropTypes.object.isRequired,
  booking: PropTypes.object.isRequired,
  bookingTypeId: PropTypes.string.isRequired
}

export default ChangeSummary



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ChangeAliadaConfirmBase/components/ChangeSummary/ChangeSummary.js